import classNames from "classnames";
import noop from "lodash/noop";
import { FunctionComponent, ReactNode } from "react";
import Radio from "@Components/atoms/Radio";
import { useBreakpoint } from "@Hooks/useBreakpoint";
import { ReactComponent as IconChevron } from "@Icons/16x16/chevron-right.svg";
import "./style.scss";

export type CheckBoxType = "round" | "square";

interface Props {
  checked: boolean;
  children: ReactNode;
  disabled?: boolean;
  errorMessage?: string;
  hasError: boolean;
  logo?: string;
  onClick: () => void;
  title: ReactNode;
}

const RadioCard: FunctionComponent<Props> = ({
  checked,
  children,
  disabled = false,
  errorMessage,
  hasError,
  logo,
  onClick,
  title,
}) => {
  const { isSmallScreen } = useBreakpoint();

  return (
    <div
      className={classNames("RadioCard", {
        "RadioCard--checked": checked,
        "RadioCard--disabled": disabled,
        "RadioCard--error": hasError,
      })}
      tabIndex={disabled || hasError ? undefined : 1}
    >
      <div className="RadioCard-tile" onClick={disabled ? noop : onClick}>
        <div className="RadioCard-tile-header">
          <div className="RadioCard-tile-header-left">
            <Radio
              checked={checked}
              disabled={disabled}
              hasError={hasError}
              onClick={noop}
              type="primary"
            />
            {title}
            {isSmallScreen && !!logo && <img className="RadioCard-tile-header-image" src={logo} />}
          </div>
          <div className="RadioCard-tile-header-right">
            {isSmallScreen ? (
              <IconChevron />
            ) : (
              !!logo && <img className="RadioCard-tile-header-image" src={logo} />
            )}
          </div>
        </div>
        <div className="RadioCard-tile-content">{children}</div>
      </div>
      {hasError && !!errorMessage && <div className="RadioCard-errorMessage">{errorMessage}</div>}
    </div>
  );
};

export default RadioCard;
